import { type FragmentType, getFragmentData, graphql } from '../../../__generated__'
import { SentContent } from '../../../Components/SentContent/SentContent'
import { defineMessages, FormattedMessage } from '../../../TypedIntl'

const messages = defineMessages({
  testingDescription: 'FollowUp.SchoolReportSent.testingDescription',
})

const fragments = {
  ReportSentTestingCompany_publicReportSource: graphql(`
    fragment ReportSentTestingCompany_publicReportSource on PublicReportSource {
      id
      sourceType
    }
  `),
}

type Props = {
  channel: FragmentType<typeof fragments.ReportSentTestingCompany_publicReportSource>
}
export const ReportSentTestingCompany = ({ channel: _channel }: Props) => {
  const channel = getFragmentData(fragments.ReportSentTestingCompany_publicReportSource, _channel)
  return (
    <SentContent
      sourceType={channel.sourceType}
      description={<FormattedMessage {...messages.testingDescription} />}
    />
  )
}
